import { getAccOrigin } from '@adsk/acs-sc-web-platform-api';

import { getRemoteRoute } from './getCurrentRoute';
import isLocal from './isLocal';
import safeGetPathname from './safeGetPathname';

const isRootRoute = (pathname: string) => {
  return pathname === '/';
};

const isLocalACC = (rawURL: string) => {
  try {
    const url = new URL(rawURL);
    return isLocal(url.hostname);
  } catch {
    return false;
  }
};

const isExoRoute = (url: string) => {
  const pathname = safeGetPathname(url);
  const isRelativeRoute = url.startsWith(pathname);
  const isInACC =
    isRelativeRoute || url.startsWith(getAccOrigin()) || isLocalACC(url);

  return (
    (isInACC && Boolean(getRemoteRoute(pathname))) || isRootRoute(pathname)
  );
};

export default isExoRoute;
